import { ElementRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WebcamService {

  constructor() {}

  currentDevice = -1;
  availableDevices = [];
  currentStream: MediaStream | undefined;

  async toggleCamera(videoPlayer: ElementRef) {

    if (this.availableDevices.length == 0) {

      const devices = await navigator.mediaDevices.enumerateDevices()

      devices.forEach(device => {

        if (device.kind == 'videoinput') {
          this.availableDevices.push(device.deviceId);
        }

      })

    }

    videoPlayer.nativeElement.pause();
    this.currentDevice = this.currentDevice >= this.availableDevices.length - 1 ? 0 : this.currentDevice + 1;

    if (this.currentStream) {
      this.currentStream.getTracks().forEach((track) => { track.stop(); });
    }

    let constraints = {
      video: {
        width: 1280,
        height: 1280,
        deviceId: this.availableDevices[this.currentDevice] ? { exact: this.availableDevices[this.currentDevice] } : undefined
      },
      audio: false
    };

    const stream = await navigator.mediaDevices.getUserMedia(constraints)
    videoPlayer.nativeElement.srcObject = stream;
    videoPlayer.nativeElement.play();
    this.currentStream = stream;

  }

  tempCanvas = document.createElement("canvas")

  async getJpegSnapshot(videoPlayer: ElementRef) {

    const context = this.tempCanvas.getContext('2d')!

    if (videoPlayer.nativeElement.videoWidth > videoPlayer.nativeElement.videoHeight) {
      this.tempCanvas.width = this.tempCanvas.height = videoPlayer.nativeElement.videoHeight;
    } else {
      this.tempCanvas.width = this.tempCanvas.height = videoPlayer.nativeElement.videoWidth;
    }

    const squareDimensions = this.getDimensions(
      videoPlayer.nativeElement.videoWidth,
      videoPlayer.nativeElement.videoHeight
    )

    context.drawImage(
      videoPlayer.nativeElement,
      squareDimensions[0],
      squareDimensions[1],
      squareDimensions[2],
      squareDimensions[3],
      0,
      0,
      this.tempCanvas.width,
      this.tempCanvas.height
    )

    return this.tempCanvas.toDataURL('image/jpeg')

  }

  getDimensions(width: number, height: number) {

    if (width > height) {

      let temp = width - height;
      let start = (temp / 2);

      let sx = start;
      let sy = 0;
      let sw = height;
      let sh = height;

      return [sx, sy, sw, sh];

    }

    if (height > width) {

      let temp = height - width;
      let start = (temp / 2);

      let sx = 0;
      let sy = start;
      let sw = width;
      let sh = width;

      return [sx, sy, sw, sh];

    }

    return [0, 0, width, height];

  }

}
